import i18n from 'i18next'
import LanguageDetector, { type DetectorOptions } from 'i18next-browser-languagedetector'
import HttpBackend, { type HttpBackendOptions } from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import {
  LanguageSource,
  sharedTranslationInitOptions,
  type TranslationOverrides,
  translationInitDetectionOptions
} from 'utils'

export const i18nInit = async (
  overrides: TranslationOverrides = { source: LanguageSource.SameOriginHttp }
) => {
  const backend: HttpBackendOptions =
    overrides.source === LanguageSource.ProdPanoramaHttp
      ? {
          crossDomain: true,
          loadPath: 'https://panorama.ag/locales/{{lng}}/{{ns}}.json'
        }
      : {}

  const resources =
    overrides.source === LanguageSource.LocalResources
      ? {
          'af-ZA': {
            translations:
              await import('../../../../services/web/public/locales/af-ZA/translations.json')
          },
          'bg-BG': {
            translations:
              await import('../../../../services/web/public/locales/bg-BG/translations.json')
          },
          'de-DE': {
            translations:
              await import('../../../../services/web/public/locales/de-DE/translations.json')
          },
          'en-US': {
            translations:
              await import('../../../../services/web/public/locales/en-US/translations.json')
          },
          'es-AR': {
            translations:
              await import('../../../../services/web/public/locales/es-AR/translations.json')
          },
          'es-MX': {
            translations:
              await import('../../../../services/web/public/locales/es-MX/translations.json')
          },
          'fr-CA': {
            translations:
              await import('../../../../services/web/public/locales/fr-CA/translations.json')
          },
          'fr-FR': {
            translations:
              await import('../../../../services/web/public/locales/fr-FR/translations.json')
          },
          'hu-HU': {
            translations:
              await import('../../../../services/web/public/locales/hu-HU/translations.json')
          },
          'it-IT': {
            translations:
              await import('../../../../services/web/public/locales/it-IT/translations.json')
          },
          'pl-PL': {
            translations:
              await import('../../../../services/web/public/locales/pl-PL/translations.json')
          },
          'pt-BR': {
            translations:
              await import('../../../../services/web/public/locales/pt-BR/translations.json')
          },
          'ro-RO': {
            translations:
              await import('../../../../services/web/public/locales/ro-RO/translations.json')
          },
          'ru-RU': {
            translations:
              await import('../../../../services/web/public/locales/ru-RU/translations.json')
          },
          'uk-UA': {
            translations:
              await import('../../../../services/web/public/locales/uk-UA/translations.json')
          },
          'zh-CN': {
            translations:
              await import('../../../../services/web/public/locales/zh-CN/translations.json')
          }
        }
      : undefined

  return (
    i18n
      .use(HttpBackend) // load translation using http -> see /public/locales
      .use(LanguageDetector)
      .use(initReactI18next)
      // for all options read: https://www.i18next.com/overview/configuration-options
      // and: https://github.com/i18next/i18next-browser-languageDetector
      // and: https://github.com/i18next/i18next-http-backend
      .init({
        ...sharedTranslationInitOptions,
        resources,
        backend,
        detection: translationInitDetectionOptions satisfies DetectorOptions
      })
  )
}
